import { useState, useEffect } from "react";
import SchoolMap from "./components/SchoolMap";
import SchoolDetail from "./components/SchoolDetail";
import "./App.css";

function App() {
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [schoolData, setSchoolData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/schools_with_coords.json`)
      .then((res) => res.json())
      .then((data) => {
        const valid = data.filter(
          (s) => s.lat && s.lon && s.hasLocalData && s.kommune === "Aabenraa"
        );
        setSchools(valid);
      });
  }, []);

  const handleSchoolSelect = (school) => {
    setSelectedSchool(school);
    setLoading(true);
    setSchoolData(null);
    fetch(`${process.env.PUBLIC_URL}/data/${school.skoleId}.json`)
      .then((res) => {
        if (!res.ok) throw new Error("No data");
        return res.json();
      })
      .then((data) => {
        setSchoolData(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleClose = () => {
    setSelectedSchool(null);
    setSchoolData(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Skoletrivsel i Aabenraa Kommune</h1>
        <p className="subtitle">
          Se hvordan eleverne trives på folkeskoler i Aabenraa Kommune
        </p>
      </header>
      <div className="App-content">
        <SchoolMap
          schools={schools}
          selectedSchool={selectedSchool}
          onSchoolSelect={handleSchoolSelect}
        />
        {selectedSchool && (
          <SchoolDetail
            school={selectedSchool}
            data={schoolData}
            loading={loading}
            onClose={handleClose}
          />
        )}
      </div>
    </div>
  );
}

export default App;
